import { Box, IconButton } from '@material-ui/core';
import React, { useEffect } from 'react';
import Typography from '../../../../atoms/typography';
import CustomDataGrid from '../../../../atoms/dataGrid';
import useGetDistributorUsers from '../../../../../hooks/distributorUser/useGetDistributorUsers';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import jwtDecode from 'jwt-decode';
import { acGetDistributorUser } from '../../../../../store/ducks/distributorUser/actions';
import ActivityIndicator from '../../../../ActivityIndicator';
import useGetDistributorUser from '../../../../../hooks/distributorUser/useGetDistributorUser';
import { ReactComponent as MenuIcon } from '../../../../../assets/icons/icon-menu.svg';
import StatusUser from '../components/status';
import ButtonComponent from '../../../../atoms/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { formatDateTime } from '../../../../../utils/formatTime';

const columns = [
  {
    field: 'username',
    flex: 1,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Nome
      </Typography>
    ),
  },
  {
    field: 'email',
    flex: 2,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        E-mail
      </Typography>
    ),
  },
  {
    field: 'distributorUserType',
    flex: 1,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Tipo
      </Typography>
    ),
  },
  {
    field: 'status',
    flex: 1,
    editable: false,
    sortable: false,
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Status
      </Typography>
    ),
    renderCell: (params: any) => <StatusUser status={params.row.status} />,
  },
  {
    field: 'createdAt',
    flex: 1,
    editable: false,
    sortable: false,
    valueFormatter: (params: any) => formatDateTime(params.value),
    renderHeader: () => (
      <Typography color="gray" fontWeight="700">
        Criado em
      </Typography>
    ),
  },
];

const Users: React.FC<any> = ({ onClick, onUserSelect }: any) => {
  const { execute, loading } = useGetDistributorUsers();
  const { execute: loadUser } = useGetDistributorUser();
  const dispatch = useDispatch();

  const { distributorUsers } = useSelector(
    (state: ApplicationState) => state.tables,
  );

  const token = useSelector(
    (state: ApplicationState) => state.distributor.token,
  );

  const tokenDecoded: any = jwtDecode(token);

  const loadUsers = async () => {
    dispatch(
      acGetDistributorUser({
        distributorUserType: '',
        username: '',
        email: '',
        status: '',
      }),
    );
    await execute({
      page: 1,
      distributorUserId: tokenDecoded.distributorId,
    });
  };

  const getDistributorUser = async (userId: string) => {
    await loadUser(tokenDecoded.distributorId, userId);
    onClick('editUser');
  };

  useEffect(() => {
    loadUsers();
  }, []);

  return (
    <Box component="div">
      <ButtonComponent
        theme="primary"
        mb={5}
        onClick={() => {
          onClick('newUser');
        }}
      >
        <FontAwesomeIcon icon={solid('plus')} size="sm" color="#fff" /> Novo
        Usuário
      </ButtonComponent>
      {loading ? (
        <ActivityIndicator />
      ) : (
        <>
          <CustomDataGrid
            columns={[
              ...columns,
              {
                field: 'actions',
                flex: 1,
                editable: false,
                sortable: false,
                renderHeader: () => (
                  <Typography color="gray" fontWeight="700">
                    Ações
                  </Typography>
                ),
                renderCell: (params: any) => (
                  <IconButton
                    aria-label="menu"
                    onClick={() => {
                      getDistributorUser(params.id);
                      onUserSelect(params.id);
                    }}
                  >
                    <MenuIcon />
                  </IconButton>
                ),
              },
            ]}
            rows={distributorUsers.rows || []}
            disableColumnFilter
            disableColumnMenu
            disableColumnSelector
            pageSize={20}
            getRowId={row => row.distributorUserId}
          />
          <hr />
        </>
      )}
    </Box>
  );
};

export default Users;
